import {createFileRoute, Outlet} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/organizations')({
  component: OrganizationsLayout,
  async beforeLoad() {
    return {
      title: 'Organizations',
      breadcrumb: {
        label: 'Organizations',
        path: '/organizations',
      },
    };
  },
});

function OrganizationsLayout() {
  return <Outlet />;
}
